"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var PersonalPromoCodesHistoryList = /** @class */ (function (_super) {
    __extends(PersonalPromoCodesHistoryList, _super);
    function PersonalPromoCodesHistoryList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Персональный оффер',
                key: "v-" + _this.props.data.dk_key,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.record.title));
                },
                width: 200,
            }, {
                title: 'Бренд',
                dataIndex: _this.props.data.dk_brand_title,
                key: _this.props.data.dk_brand_title,
                width: 200,
            }, {
                title: 'Игрок',
                dataIndex: _this.props.data.dk_player_login,
                key: _this.props.data.dk_player_login,
                width: 200,
            }, {
                title: 'Сотрудник',
                dataIndex: _this.props.data.dk_admin_login,
                key: _this.props.data.dk_admin_login,
                width: 200,
            }, {
                title: 'Промокод',
                dataIndex: _this.props.data.dk_promo_code_title,
                key: _this.props.data.dk_promo_code_title,
                width: 200,
            }, {
                title: 'Сообщение',
                dataIndex: _this.props.data.dk_message_to_player,
                key: _this.props.data.dk_message_to_player,
                width: 200,
            }, {
                title: 'Создан',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 200,
            }
        ];
        return _this;
    }
    PersonalPromoCodesHistoryList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat,
                pageSize: data.tablePageSize
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: [],
            pageNum: 1,
            pageSize: this.props.state.getTablePageSize(),
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
            //this.props.state.setExtBreadCrumbPath(["Список кодов", `Логи активаций`]);
            _this.props.state.setExtBreadCrumbPath(["\u0421\u043F\u0438\u0441\u043E\u043A \u043A\u043E\u0434\u043E\u0432", "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434\u043E\u0432 - [" + _this.props.record.description + "]"]);
        });
    };
    PersonalPromoCodesHistoryList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PersonalPromoCodesHistoryList.prototype.onPageLogsConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ pageNum: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    /*public componentWillReceiveProps(nextProps: PromoCodeTemplateCodesLogsListProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, () => {
                this.loadData(nextProps);
            });
        }
    }*/
    PersonalPromoCodesHistoryList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            personal_promocode_offer_id: Props.record.key,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    PersonalPromoCodesHistoryList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.onPageLogsConfigChange) {
                    _this.onPageLogsConfigChange(_page, PageSize);
                }
            });
        });
    };
    PersonalPromoCodesHistoryList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PersonalPromoCodesHistoryList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    PersonalPromoCodesHistoryList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434:"),
                            " [",
                            record.promo_code_title,
                            "]")));
                }, scroll: { x: true } })));
    };
    return PersonalPromoCodesHistoryList;
}(React.Component));
exports.default = PersonalPromoCodesHistoryList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_personal/ui/component/PersonalPromoCodesHistoryList.tsx
// module id = 2584
// module chunks = 0